var React = require('react');

function ReportLrg (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.927 8.41478V4H35.073V8.41478H42.8696C43.493 8.41478 44 8.91627 44 9.53282V44.8807C43.9997 45.1774 43.8804 45.4621 43.6683 45.6719C43.4561 45.8817 43.1685 45.9997 42.8685 46H7.13169C6.8317 45.9997 6.54386 45.8817 6.33173 45.6719C6.11976 45.4622 6.00047 45.178 6 44.8815L6 9.53282C6 8.91627 6.50702 8.41478 7.13038 8.41478H14.927ZM35.073 10.6818V15.0965H14.927V10.6818H8.29201V43.733H41.708V10.6818H35.073ZM19.7512 36.1606H17.3945V29.3795H19.7512V36.1606ZM24.0362 36.1606L21.6794 36.1606L21.6796 20.1967L24.0363 20.1967L24.0362 36.1606ZM28.3211 36.1606H25.9644V24.7881H28.3211V36.1606ZM32.6061 36.1606H30.2494V22.3158H32.6061V36.1606ZM32.781 6.26699H17.219V12.8296H32.781V6.26699Z","fill":"#656976"}));
}

ReportLrg.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none"};

module.exports = ReportLrg;

ReportLrg.default = ReportLrg;
